import {_formatKeyMapping} from './_mapping-helper'

/**
 * di-ding
 * @see http://blog.cloudself.cn/di-ding
 * version 0.0.2
 * router-maps
 * change logs:
 * 2018/1/24 herbluo created
 */
const maps = {}

export const _registerConfig = (diName, config) => {
  maps[diName] = format(config)
}

export default maps

/* *********
 private
 ********* */
const format = config => {
  const {
    // 界面
    center,
    current,
    create,
    modify,
    // 基本请求
    get,
    delete: _delete,
    getCurrent,
    post,
    // 其它
    // keyMappingOriginal, // 必须
    // keyMappingEntities, // 必须
    mapping,
    ...others
  } = config

  const {
    keyMapping,
    keyMappingEntities
  } = _formatKeyMapping(mapping)

  config.keyMappingOriginal = keyMapping
  config.keyMappingEntities = keyMappingEntities

  ;['center', 'current', 'create', 'modify'].forEach(it => {
    if (config[it]) {
      // 生成部分属性
      config[it].keyMappingEntities = getKeyMappingOf(keyMappingEntities, it)

      // 转换部分属性
      if (typeof config[it].title === 'string') {
        config[it].title = [config[it].title]
      }

      // 并入公共属性
      config[it] = Object.assign({}, others, config[it])
    }
  })

  return config
}

const getKeyMappingOf = (keyMappingEntities, name) =>
  keyMappingEntities.filter(([, {showIn}]) => showIn.find(it => it === name))



// WEBPACK FOOTER //
// ./src/components/common/di-ding/_content-maps.js